module.exports = __webpack_public_path__ + "img/die-4.f25a3b98.svg";